export const MARKETPLACE_ROUTE = '/marketplace';

export const MARKETPLACE_SETUP_ROUTE = '/marketplace/setup';

export const MARKETPLACE_SETUP_NEW_SEGMENT = 'new';

export const MARKETPLACE_SETUP_QUERY_DATASERVICE = 'dataservice';

export const MARKETPLACE_SETUP_QUERY_AUTH_TYPE = 'authType';

export const MARKETPLACE_CONNECTION_ROUTE = '/marketplace/connections';

export const marketplaceSetupPath = (datasourceUuid: string): string => (
	`${MARKETPLACE_SETUP_ROUTE}/${datasourceUuid}`
);

/** Draft setup before first save — no datasource row exists yet. */
export const marketplaceSetupNewPath = (
	dataserviceUuid: string,
	authenticationTypeUuid?: string,
): string => {
	const params = new URLSearchParams({
		[MARKETPLACE_SETUP_QUERY_DATASERVICE]: dataserviceUuid,
	});
	if (authenticationTypeUuid) {
		params.set(MARKETPLACE_SETUP_QUERY_AUTH_TYPE, authenticationTypeUuid);
	}
	return `${MARKETPLACE_SETUP_ROUTE}/${MARKETPLACE_SETUP_NEW_SEGMENT}?${params.toString()}`;
};

export const marketplaceConnectionPath = (datasourceUuid: string): string => (
	`${MARKETPLACE_CONNECTION_ROUTE}/${datasourceUuid}`
);

export const MARKETPLACE_DETAIL_TAB_QUERY = 'view';

export const MARKETPLACE_DETAIL_TAB = {
	STATUS: 'status',
	SETTINGS: 'settings',
} as const;

export type MarketplaceDetailTab = typeof MARKETPLACE_DETAIL_TAB[keyof typeof MARKETPLACE_DETAIL_TAB];

export const MARKETPLACE_PERMISSIONS = {
	/** Sole marketplace access permission (View/Edit retired). */
	CONNECT: 'Marketplace.Connect',
	IMMEDIATE_SYNC: 'Marketplace.ImmediateSync',
	DELETE: 'Marketplace.Delete',
	VIEW_INTERNAL_FIELDS: 'Marketplace.ViewInternalFields',
	/** Reveal a secret the customer entered on a datasource. */
	VIEW_SECRETS: 'Marketplace.ViewSecrets',
	/** Reveal the secret of an internal or system-managed field (app secret, tokens), and set an internal field per datasource. */
	VIEW_INTERNAL_SECRETS: 'Marketplace.ViewInternalSecrets',
} as const;

export const MARKETPLACE_TAB_QUERY = 'tab';

export const MARKETPLACE_TAB = {
	CONNECTIONS: 'connections',
	INTEGRATIONS: 'integrations',
} as const;

export type MarketplaceTab = typeof MARKETPLACE_TAB[keyof typeof MARKETPLACE_TAB];

export const MARKETPLACE_TAB_INDEX = {
	[MARKETPLACE_TAB.CONNECTIONS]: 0,
	[MARKETPLACE_TAB.INTEGRATIONS]: 1,
} as const;

/** Server page size for marketplace Connections. Must match the table default. */
export const MARKETPLACE_PAGE_SIZE = 10;

export const MARKETPLACE_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const;

export const MARKETPLACE_LIST_STATUS = {
	ALL: 'all',
	ACTIVE: 'active',
	NOT_CONNECTED: 'not-connected',
	FAILED: 'failed',
} as const;

export type MarketplaceListStatus = typeof MARKETPLACE_LIST_STATUS[keyof typeof MARKETPLACE_LIST_STATUS];

/** Poll interval for the datasource list and detail pages; detail refreshes when connector
 * status changes, the list silently refetches so counts/chips stay current. */
export const MARKETPLACE_POLL_MS = 60_000;

export const DATASERVICE_LOGO_PLACEHOLDER = '/no-image-dataservice-placeholder.png';

export const DATASOURCE_FIELD_VALUES_FORM_KEY = 'datasourceFieldValues';

export const UNCHANGED_SECRET_MASK = '••••••••••••••••••••';
